import gql from 'graphql-tag';
import { useQuery } from 'urql';

import { GameDescriptor } from '@/fragments/GameDescriptor';
import { useQueryParams } from '@/hooks';
import { assert } from '@/utils/error';
import {
  TransactionInspectionQuery,
  TransactionInspectionQueryVariables,
} from './__generated__/useTransaction';
import { queryParams } from './queryParams';

const TRANSACTION_QUERY = gql`
  query TransactionInspection($rawId: String!) {
    viewer {
      id
      transactionsV2(rawId: $rawId, orderBy: processedAt, desc: true) {
        edges {
          node {
            rawTransactionId
            uuid
            transactionId
            playerId
            playerSessionId
            playerSessionUUID
            gameId
            gameRoundId
            isRoundFinished
            extTransactionId
            payload
            gameSessionId
            provider
            gameProvider
            brand {
              id
              name
            }
            processedAt
            paymentMethod
            paymentStatus
            transactionType
            openingBalance
            closingBalance
            currency
            comment
            paymentFee {
              money {
                amount
                currency
              }
            }
            amount
            brand {
              code
            }
            initiator {
              ... on PlayerInitiator {
                player {
                  id
                  firstName
                  lastName
                  email
                }
              }
              ... on AgentInitiator {
                agent {
                  email
                  firstName
                  lastName
                }
              }
            }
            gameDescriptor: gameDescriptorV2 {
              ...GameDescriptor
            }
          }
        }
      }
    }
  }
  ${GameDescriptor}
`;

export default function useTransaction() {
  const [query] = useQueryParams(queryParams);

  assert(query.rawTransactionId, 'transaction id missing');

  const [{ data, fetching }, refresh] = useQuery<
    TransactionInspectionQuery,
    TransactionInspectionQueryVariables
  >({
    query: TRANSACTION_QUERY,
    variables: {
      rawId: query.rawTransactionId,
    },
  });

  return {
    refresh,
    fetching,
    transaction: data?.viewer.transactionsV2?.edges?.[0]?.node,
  };
}
